import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FormHelper } from '@app/shared/helpers/form';
import { ILogin } from '@app/modules/auth/interface/login';
import { PasswordValidator } from '@app/shared/validators/password';
import { PasswordType } from '@app/shared/types/password-type';
import { customEmailValidator } from '@app/shared/validators/email';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
})
export class LoginFormComponent implements OnInit {
  @Output() public submitEvent = new EventEmitter<ILogin>();

  public form: FormGroup;

  public passwordType: PasswordType = 'password';

  public get email(): FormControl {
    return this.form.get('email') as FormControl;
  }

  public get password(): FormControl {
    return this.form.get('password') as FormControl;
  }

  constructor(private readonly fb: FormBuilder) {}

  public ngOnInit(): void {
    this.createForm();
  }

  public submit(): void {
    FormHelper.markAllAsDirty(this.form);

    if (this.form.valid) {
      this.submitEvent.emit(this.form.value);
    }
  }

  public onScanMolstQR(): void {
    // Navigate to the public MOLST lookup page
    window.location.href = '/public-molst-lookup';
  }

  public getErrorMessage(key: string, control: FormControl): string {
    return FormHelper.getErrorMessage(key, control);
  }

  private createForm(): void {
    this.form = this.fb.group({
      email: ['', [Validators.required, customEmailValidator()]],
      password: [
        '',
        [Validators.required, Validators.minLength(8), PasswordValidator],
      ],
    });

    // Removed reCAPTCHA control
  }
}
